<ng-container ntapWindowRegistry>
    <ntap-dynamic [compId]="filterCompId"></ntap-dynamic>
</ng-container>
<ntap-view-window target="detail" [contentTemplate]="viewWindowContent">
    <ng-template #viewWindowContent let-defaultTemplate>
        <ntap-prime-popupview appendTo="body">
            <ng-container *ngTemplateOutlet="defaultTemplate"></ng-container>
        </ntap-prime-popupview>
    </ng-template>
</ntap-view-window>
<ng-container *ngIf="(treeTableMeta$ | async) as tableMeta; else loadingView">
    <ng-container *ngIf="(tableData$ | async) as tableData; else loadingView">
        <p-card>
            <ntap-dynamic [compId]="tableToolbarCompId"></ntap-dynamic>
            <ng-container *ngIf="nodes$ | async as nodes">
                <p-treeTable 
                    [paginator]="true"
                    [rowsPerPageOptions]="(rowsPerPageOptions$ | async) ?? defaultRowsPageOptions" 
                    [rows]="tableData.rows"
                    [totalRecords]="tableData.totalRecords"  
                    [lazy]="tableMeta.pagingSetup.lazy"
                    (onPage)="tableMeta.pagingSetup.pageHandler($event, tableData)"
                    [dataKey]="dataKey"
                    (onSort)="tableMeta.pagingSetup.sortHandler($event)"
                    [value]="nodes" [selectionMode]="(tableMeta.selectionMode === '' || tableMeta.selectionMode === 'single') ? 'single' : 'checkbox'" [(selection)]="selected"
                    [columns]="tableMeta.columns" (onNodeSelect)="setSelectedItems($event)"
                    (onNodeUnselect)="unsetSelectedItems($event)" (onNodeExpand)="nodeExpand($event, nodes)"
                    (onNodeCollapse)="nodeCollapse($event)"
                    [loading]="(loadingState$ | async) ?? true" [class]="'hierarchy-table-view ' + tableMeta.viewName"
                    [first]="tableData.firstIndex"
                    #tree>
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th class="table-col-checkbox"></th>
                            <th *ngFor="let column of columns" [ttSortableColumn]="column.name" [class]="'hierarchy-table-column ' + column.name.replaceAll('~','-')">
                                {{ column.description }}
                                <p-treeTableSortIcon [field]="column.name" ariaLabel="true"></p-treeTableSortIcon>
                            </th>
                            <th ntapDebug>vstamp/Instance</th>
                            <th *ngIf="tableMeta.hasActions" class="table-col-actions"></th>
                        </tr>
                    </ng-template>
                    <ng-template let-rowNode pTemplate="body" let-rowData="rowData" let-rowIndex="rowIndex"
                        let-columns="columns">
                        <ng-container ntapListItemProvider [item]="rowNode.node.originalData" [listIndex]="rowNode.node.key">
                            <tr [ttRow]="rowNode" [ttSelectableRow]="rowNode" [ttSelectableRowDisabled]="!rowNode.node.selectable">
                                <td class="table-col-checkbox">
                                    <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                                    <ng-container *ngIf="tableMeta.selectionMode !== '' && tableMeta.selectionMode !== 'single'">
                                        <p-treeTableCheckbox [value]="rowNode"></p-treeTableCheckbox>
                                    </ng-container>
                                </td>
                                <td *ngFor="let column of columns; let i = index" [class]="'hierarchy-table-column ' + column.name.replaceAll('~','-')">
                                    {{ rowData[column.name] }}
                                </td>
                                <td *ngIf="tableMeta.hasActions" class="table-col-actions">
                                    <span class="ui-cell-content">
                                        <ntap-dynamic [compId]="DEFAULT_ACTION_BAR_COMP_ID"></ntap-dynamic>
                                    </span>
                                </td>
                        </ng-container>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                            <td [attr.colspan]="tableMeta.totalColumns" class="table-data-no-overflow">
                                Nema podataka.
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="paginatorleft" let-state>
                        {{ state.first + 1 }}-{{ (state.first + state.rows > state.totalRecords) ? state.totalRecords : state.first
                        +
                        state.rows }}
                        od {{ state.totalRecords }}
                      </ng-template>
                </p-treeTable>
            </ng-container>
        </p-card>
    </ng-container>
</ng-container>
<ng-template #loadingView>
    <p-progressSpinner></p-progressSpinner>
</ng-template>
